import { ref } from 'vue'
import api from '@/utils/axiosConfig'
import { useNotifications } from './useNotifications'

const API_URL = ''

export function useCatalogosNew() {
  const { showSuccess, showError } = useNotifications()
  const loading = ref(false)
  const tiposComponente = ref([])
  const catalogos = ref([])
  const campos = ref([])
  const registros = ref([])
  const secciones = ref([])
  const prototipos = ref([])

  // ========== Tipos de Componente ==========
  const fetchTiposComponente = async () => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/tipos-componentes-new`)
      tiposComponente.value = response.data
      return response.data
    } catch (error) {
      showError('Error al cargar tipos de componente')
      throw error
    } finally {
      loading.value = false
    }
  }

  const createTipoComponente = async (data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/tipos-componentes-new`, data)
      showSuccess('Tipo de componente creado exitosamente')
      await fetchTiposComponente()
      return response.data
    } catch (error) {
      showError('Error al crear tipo de componente')
      throw error
    } finally {
      loading.value = false
    }
  }

  const updateTipoComponente = async (id, data) => {
    loading.value = true
    try {
      const response = await api.put(`${API_URL}/tipos-componentes-new/${id}`, data)
      showSuccess('Tipo de componente actualizado exitosamente')
      await fetchTiposComponente()
      return response.data
    } catch (error) {
      showError('Error al actualizar tipo de componente')
      throw error
    } finally {
      loading.value = false
    }
  }

  const deleteTipoComponente = async (id) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/tipos-componentes-new/${id}`)
      showSuccess('Tipo de componente eliminado exitosamente')
      await fetchTiposComponente()
    } catch (error) {
      showError('Error al eliminar tipo de componente')
      throw error
    } finally {
      loading.value = false
    }
  }

  // ========== Catálogos ==========
  const fetchCatalogos = async () => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/catalogos-new`)
      catalogos.value = response.data
      return response.data
    } catch (error) {
      showError('Error al cargar catálogos')
      throw error
    } finally {
      loading.value = false
    }
  }

  const fetchCatalogo = async (id) => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/catalogos-new/${id}`)
      return response.data
    } catch (error) {
      showError('Error al cargar catálogo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const createCatalogo = async (data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/catalogos-new`, data)
      showSuccess('Catálogo creado exitosamente')
      await fetchCatalogos()
      return response.data
    } catch (error) {
      showError('Error al crear catálogo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const updateCatalogo = async (id, data) => {
    loading.value = true
    try {
      const response = await api.put(`${API_URL}/catalogos-new/${id}`, data)
      showSuccess('Catálogo actualizado exitosamente')
      await fetchCatalogos()
      return response.data
    } catch (error) {
      showError('Error al actualizar catálogo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const deleteCatalogo = async (id) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/catalogos-new/${id}`)
      showSuccess('Catálogo eliminado exitosamente')
      await fetchCatalogos()
    } catch (error) {
      showError('Error al eliminar catálogo')
      throw error
    } finally {
      loading.value = false
    }
  }

  // ========== Campos de Catálogo ==========
  const fetchCamposByCatalogo = async (catalogoId) => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/campos-catalogo-new?catalogoId=${catalogoId}`)
      campos.value = response.data
      return response.data
    } catch (error) {
      showError('Error al cargar campos')
      throw error
    } finally {
      loading.value = false
    }
  }

  const createCampo = async (data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/campos-catalogo-new`, data)
      showSuccess('Campo creado exitosamente')
      await fetchCamposByCatalogo(data.catalogoId)
      return response.data
    } catch (error) {
      showError('Error al crear campo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const updateCampo = async (id, data) => {
    loading.value = true
    try {
      const response = await api.put(`${API_URL}/campos-catalogo-new/${id}`, data)
      showSuccess('Campo actualizado exitosamente')
      return response.data
    } catch (error) {
      showError('Error al actualizar campo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const deleteCampo = async (id, catalogoId) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/campos-catalogo-new/${id}`)
      showSuccess('Campo eliminado exitosamente')
      await fetchCamposByCatalogo(catalogoId)
    } catch (error) {
      showError('Error al eliminar campo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const updateCamposCatalogo = async (catalogoId, campos) => {
    loading.value = true
    try {
      const response = await api.put(`${API_URL}/catalogos-new/${catalogoId}/campos`, { campos })
      showSuccess('Campos del catálogo actualizados exitosamente')
      await fetchCatalogos()
      return response.data
    } catch (error) {
      showError('Error al actualizar campos del catálogo')
      throw error
    } finally {
      loading.value = false
    }
  }

  // ========== Registros de Catálogo ==========
  const fetchRegistrosByCatalogo = async (catalogoId) => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/registros-catalogo-new?catalogoId=${catalogoId}`)
      registros.value = response.data
      return response.data
    } catch (error) {
      showError('Error al cargar registros')
      throw error
    } finally {
      loading.value = false
    }
  }

  const createRegistro = async (data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/registros-catalogo-new`, data)
      showSuccess('Registro creado exitosamente')
      await fetchRegistrosByCatalogo(data.catalogoId)
      return response.data
    } catch (error) {
      showError('Error al crear registro')
      throw error
    } finally {
      loading.value = false
    }
  }

  const updateRegistro = async (id, data) => {
    loading.value = true
    try {
      const response = await api.put(`${API_URL}/registros-catalogo-new/${id}`, data)
      showSuccess('Registro actualizado exitosamente')
      return response.data
    } catch (error) {
      showError('Error al actualizar registro')
      throw error
    } finally {
      loading.value = false
    }
  }

  const deleteRegistro = async (id, catalogoId) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/registros-catalogo-new/${id}`)
      showSuccess('Registro eliminado exitosamente')
      await fetchRegistrosByCatalogo(catalogoId)
    } catch (error) {
      showError('Error al eliminar registro')
      throw error
    } finally {
      loading.value = false
    }
  }

  // ========== Secciones ==========
  const fetchSecciones = async () => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/secciones-new`)
      secciones.value = response.data
      return response.data
    } catch (error) {
      showError('Error al cargar secciones')
      throw error
    } finally {
      loading.value = false
    }
  }

  const createSeccion = async (data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/secciones-new`, data)
      showSuccess('Sección creada exitosamente')
      await fetchSecciones()
      return response.data
    } catch (error) {
      showError('Error al crear sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  const updateSeccion = async (id, data) => {
    loading.value = true
    try {
      const response = await api.put(`${API_URL}/secciones-new/${id}`, data)
      showSuccess('Sección actualizada exitosamente')
      await fetchSecciones()
      return response.data
    } catch (error) {
      showError('Error al actualizar sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  const deleteSeccion = async (id) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/secciones-new/${id}`)
      showSuccess('Sección eliminada exitosamente')
      await fetchSecciones()
    } catch (error) {
      showError('Error al eliminar sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  // ========== Sección - Tipo Componente ==========
  const obtenerTiposDeSeccion = async (seccionId) => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/seccion-tipo-componente-new?seccionId=${seccionId}`)
      return response.data
    } catch (error) {
      showError('Error al cargar tipos de componente de la sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  const asignarTipoASeccion = async (data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/seccion-tipo-componente-new`, data)
      showSuccess('Tipo de componente asignado exitosamente')
      return response.data
    } catch (error) {
      showError('Error al asignar tipo de componente')
      throw error
    } finally {
      loading.value = false
    }
  }

  const desasignarTipoDeSeccion = async (id) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/seccion-tipo-componente-new/${id}`)
      showSuccess('Tipo de componente desasignado exitosamente')
    } catch (error) {
      showError('Error al desasignar tipo de componente')
      throw error
    } finally {
      loading.value = false
    }
  }

  // ========== Sección - Catálogo (Nueva relación directa) ==========
  const obtenerCatalogosDeSeccion = async (seccionId) => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/secciones-new/${seccionId}/catalogos`)
      return response.data
    } catch (error) {
      showError('Error al cargar catálogos de la sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  const asignarCatalogoASeccion = async (data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/seccion-catalogo-new`, data)
      showSuccess('Catálogo asignado a sección exitosamente')
      return response.data
    } catch (error) {
      showError('Error al asignar catálogo a sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  const desasignarCatalogoDeSeccion = async (id) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/seccion-catalogo-new/${id}`)
      showSuccess('Catálogo desasignado de sección exitosamente')
    } catch (error) {
      showError('Error al desasignar catálogo de sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  // ========== Prototipos V2 ==========
  const fetchPrototipos = async () => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/prototipos-new`)
      prototipos.value = response.data
      return response.data
    } catch (error) {
      showError('Error al cargar prototipos')
      throw error
    } finally {
      loading.value = false
    }
  }

  const fetchPrototipo = async (id) => {
    loading.value = true
    try {
      const response = await api.get(`${API_URL}/prototipos-new/${id}`)
      return response.data
    } catch (error) {
      showError('Error al cargar prototipo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const createPrototipo = async (data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/prototipos-new`, data)
      showSuccess('Prototipo creado exitosamente')
      return response.data
    } catch (error) {
      showError('Error al crear prototipo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const updatePrototipo = async (id, data) => {
    loading.value = true
    try {
      const response = await api.put(`${API_URL}/prototipos-new/${id}`, data)
      showSuccess('Prototipo actualizado exitosamente')
      return response.data
    } catch (error) {
      showError('Error al actualizar prototipo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const deletePrototipo = async (id) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/prototipos-new/${id}`)
      showSuccess('Prototipo eliminado exitosamente')
      await fetchPrototipos()
    } catch (error) {
      showError('Error al eliminar prototipo')
      throw error
    } finally {
      loading.value = false
    }
  }

  const addSeccionToPrototipo = async (prototipoId, data) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/prototipos-new/${prototipoId}/secciones`, data)
      showSuccess('Sección agregada exitosamente')
      return response.data
    } catch (error) {
      showError('Error al agregar sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  const deleteSeccionPrototipo = async (prototipoSeccionId) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/prototipo-secciones-new/${prototipoSeccionId}`)
      showSuccess('Sección eliminada exitosamente')
    } catch (error) {
      showError('Error al eliminar sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  const updateComponentePrototipo = async (componenteId, data) => {
    loading.value = true
    try {
      const response = await api.put(`${API_URL}/prototipo-componentes-new/${componenteId}`, data)
      showSuccess('Componente actualizado exitosamente')
      return response.data
    } catch (error) {
      showError('Error al actualizar componente')
      throw error
    } finally {
      loading.value = false
    }
  }

  const deleteComponentePrototipo = async (componenteId) => {
    loading.value = true
    try {
      await api.delete(`${API_URL}/prototipo-componentes-new/${componenteId}`)
      return true
    } catch (error) {
      showError('Error al eliminar componente')
      throw error
    } finally {
      loading.value = false
    }
  }

  const sincronizarSeccionPrototipo = async (prototipoSeccionId) => {
    loading.value = true
    try {
      const response = await api.post(`${API_URL}/prototipo-secciones-new/${prototipoSeccionId}/sincronizar`)
      showSuccess('Sección sincronizada exitosamente')
      return response.data
    } catch (error) {
      showError('Error al sincronizar sección')
      throw error
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    tiposComponente,
    catalogos,
    campos,
    registros,
    secciones,
    // Tipos de Componente
    fetchTiposComponente,
    createTipoComponente,
    updateTipoComponente,
    deleteTipoComponente,
    // Catálogos
    fetchCatalogos,
    fetchCatalogo,
    createCatalogo,
    updateCatalogo,
    deleteCatalogo,
    // Campos
    fetchCamposByCatalogo,
    createCampo,
    updateCampo,
    deleteCampo,
    updateCamposCatalogo,
    // Registros
    fetchRegistrosByCatalogo,
    createRegistro,
    updateRegistro,
    deleteRegistro,
    // Secciones
    fetchSecciones,
    createSeccion,
    updateSeccion,
    deleteSeccion,
    // Sección - Tipo Componente
    obtenerTiposDeSeccion,
    asignarTipoASeccion,
    desasignarTipoDeSeccion,
    // Sección - Catálogo
    obtenerCatalogosDeSeccion,
    asignarCatalogoASeccion,
    desasignarCatalogoDeSeccion,
    // Prototipos V2
    prototipos,
    fetchPrototipos,
    fetchPrototipo,
    createPrototipo,
    updatePrototipo,
    deletePrototipo,
    addSeccionToPrototipo,
    deleteSeccionPrototipo,
    updateComponentePrototipo,
    deleteComponentePrototipo,
    sincronizarSeccionPrototipo
  }
}
